import { SearchOutlined } from '@ant-design/icons';
import { Button, ButtonProps, Input, Space, Typography } from 'antd';
import React from 'react';
import classes from './ListLayout.module.scss';
import { SearchProps } from 'antd/lib/input';

type Props = {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  exportData?: React.ReactNode;
  showSearch?: boolean;
  showCreate?: boolean;
  searchInputProps?: SearchProps;
  createButtonProps?: ButtonProps;
  createButtonText?: React.ReactNode;
  onCreate?: () => void;
  onSearch?: (keyword: string) => void;
  children?: React.ReactNode;
  keyword?: string;
};
export default function ListLayout(props: Props) {
  const {
    icon,
    title,
    createButtonProps,
    createButtonText,
    searchInputProps,
    onCreate,
    onSearch,
    children,
    exportData,
    showSearch = true,
    showCreate = true
  } = props;

  return (
    <div className={classes.layout}>
      <div className={classes.header}>
        <div className={classes.left}>
          {icon && <span className={classes.icon}>{icon}</span>}

          <Space className={classes.title}>
            <Typography.Title level={3}>{title}</Typography.Title>
          </Space>
          <div hidden={!showSearch} className={classes.wrapperSearch}>
            <Input.Search
              allowClear
              prefix={<SearchOutlined />}
              size="large"
              onSearch={onSearch}
              enterButton={<Button type="primary">Search</Button>}
              {...searchInputProps}
            ></Input.Search>
          </div>
        </div>
        <div className={classes.right}>
          {exportData}
          <Button
            hidden={!showCreate}
            type="primary"
            size="large"
            onClick={onCreate}
            {...createButtonProps}
          >
            {typeof createButtonText === null
              ? null
              : createButtonText || 'Create New'}
          </Button>
        </div>
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  );
}
